
  import * as ipxRuntime$cGZLnzxoKAJ65HwFg8ZBnKgV5BwZAv9228IC4JNP5QU from '/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "new-asoundeffect.ddev.site",
    "asoundeffect.com",
    "www.asoundeffect.com",
    "int.test-env.asoundeffect.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$cGZLnzxoKAJ65HwFg8ZBnKgV5BwZAv9228IC4JNP5QU, defaults: {} }
    }
  }
